// import React from 'react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/style.css';
import '../assets/css/style.css.map';
import '../assets/css/slick.min.css';
import patwedges from "../assets/img/update_2/normal/patwedges.png";
import pattyburger11 from "../assests/img/ProductsImages/PotatoBurgerPatty1.jpg";
import hashbrown1 from "../assets/img/update_2/normal/hashbrown1.jpg";
import hashbrown12 from "../assests/img/ProductsImages//HashBrown.jpg";
import herbchillyburgerpatty from "../assests/img/ProductsImages/HerbandChilliBurgerPatty.jpg";
import alootikki from "../assets/img/update_2/normal/alootikki01.png";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import potatoban1 from "../assets/img/potatoban1.png";
import header_privacy from "../assets/img/header_privacy.png";

import Footer from './footer';

const Privacypolicy = () => {
    // const location = useLocation();

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, [location]);
    const settingsscroll = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        appendDots: dots => (
            <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#ff0000' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };
    return (
        <div>
            {/* <div className="breadcumb-wrapper" style={{ backgroundImage: `url(${breadcumb_bg_2})` }}>
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">Products</h1>
                        <ul class="breadcumb-menu">
                            <li><Link to="/Idgnew/home">Home</Link></li>
                            <li>Products</li>
                        </ul>
                    </div>
                </div>
            </div> */}
            <div classNameName="d-none d-md-block">
                <div id="slider" classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
                    style={{ margin: '0 auto' }}>
                    <div classNameName="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">
                        <div className="infrastructure-name">
                            <div style={{ marginTop: "-40px" }}>
                                <ul style={{ listStyleType: 'none', padding: 20 }}>
                                    <li><h1 style={{ color: 'white', margin: 0, padding: 0 ,fontFamily:'helvetica',color:'white'}}>PRIVACY POLICY</h1></li>
                                    <li>
                                        <Link to="/home" style={{ color: 'white', padding: 4 }}><span className="homeclass" style={{ fontFamily:'helvetica' }}>Home</span> &nbsp;</Link>
                                        <span style={{ color: 'white' }}>&gt; &nbsp;<span className="redname" style={{ fontFamily:'helvetica',color:'#F0B323',color: '#0f1138'}}>Privacy Policy</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <img
                            width="2000"
                            height=""
                            src={header_privacy}
                            className="ls-l ls-img-layer factory"
                            alt="image"
                            decoding="async"
                            style={{
                                fontSize: '36px',
                                height: "",
                                color: '#000',
                                stroke: '#000',
                                strokeWidth: '0px',
                                textAlign: 'right',
                                fontStyle: 'normal',
                                textDecoration: 'none',
                                textTransform: 'none',
                                fontWeight: '400',
                                letterSpacing: '0px',
                                backgroundPosition: '0% 0%',
                                backgroundRepeat: 'no-repeat',
                                backgroundClip: 'border-box',
                                overflow: 'visible',
                                left: '0px',
                                top: '107px',
                                WebkitBackgroundClip: 'border-box'
                            }}
                            data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                        />
                    </div>
                </div>
            </div>



            <div className="about-sec overflow-hidden my-5 pb-5" >
                <div className="container">
                    <p>At <b>YUMWAY</b> (a brand by Gobind Ram Kahan Chand), we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard the details you share with us through our distributor enquiry forms and campaigns.</p>

                    <h5>1. Information We Collect</h5>
                    <p>When you fill out our enquiry forms, we may collect:</p>
                    <ul>
                        <li>Name</li>
                        <li>Email Address</li>
                        <li>Phone Number</li>
                        <li>Company/Business Name</li>
                        <li>City/Location</li>
                        <li>Any other details you voluntarily provide</li>
                    </ul>


                    <h5>2. How We Use Your Information</h5>
                    <p>We use your information only for the following purposes:</p>
                    <ul>
                        <li>To respond to your enquiry about distributorship opportunities</li>
                        <li>To share product catalogues, pricing, and business details</li>
                        <li>To follow up with you via email, phone, or WhatsApp</li>
                        <li>To improve our products and services</li>
                    </ul> 

                    <h5>3. Data Sharing</h5>
                    <p>We do not sell or rent your personal information to third parties. We may share data only in these cases:</p>
                    <ul>
                        <li>With our internal sales and support teams to respond to your request</li>
                        <li>When required by law or government authorities</li>
                    </ul> 

                    <h5>4. Data Security</h5>
                    <p>We take reasonable measures to protect your data from unauthorized access, disclosure, alteration, or destruction.</p>

                    <h5>5. Your Rights</h5>
                    <p>You may request to update, correct, or delete your personal information by contacting us at the email below.</p>


                    <h5>6. Contact Us</h5>
                    <p>If you have questions about this Privacy Policy or how your data is used, please contact us at: <br/>
                        <b>Email:</b> support@icedreamglobal.com</p>
                                                                                                

                        
                </div>
            </div>            

            <br />
            <Footer />
        </div>
    );
};

export default Privacypolicy;
